export enum DataCategoryType {
  ASSIGNMENT = 'assignment',
  PATIENT = 'patient',
  STAFF = 'staff',
  SHIFT = 'shift',
  CONFIG = 'config',
  SECURITY_ASSIGNMENT = 'securityAssignment',
  ALERT = 'alert',
  TASK = 'task',
  ASSISTREQ = 'assistreq',
  DEPARTMENT = 'department',
  NURSE = 'nurseCall',
  ALARM = 'alarm',
}
